const analyzes = {
  date: (context) => {
    const data = (context == null ? void 0 : context.split(":")) || [];
    const cHours = Number(data == null ? void 0 : data[0]) || 0;
    const cMinutes = Number(data == null ? void 0 : data[1]) || 0;
    const cSeconds = Number(data == null ? void 0 : data[2]) || 0;
    return [cHours, cMinutes, cSeconds];
  }
};

export { analyzes };
//# sourceMappingURL=utils.mjs.map
